//TODO: here we will be having input field where the user will add products to cart (check for local storage).
//and on clicking on checkout go to checkout component.


import React, {Component} from 'react';
import { db } from "../firebase";
import withAuthorization from "./withAuthorization";
import pinList from "../constants/GlobalVar";
import Checkout from './Checkout';
import { Card, Button,Label, CardTitle, CardText, Row, Col, Alert } from 'reactstrap';
import Divider from './Divider'

var u;
class ItemEntry extends Component {

    state = {
        users: null,
        loading: true,
      };
      
    constructor(props) {
        super(props);
        const { loggedUser } = this.props;

        this.clearRef = React.createRef();
        this.state = {
            wishlist: '',
            quantity: '',
            completeWishlist: [],
            userID: '',
            addr: '',
            phone: '',
            checkoutClicked: false,
            somethingInCart: false,
        }
        // console.log("mmmmmmmmmm"+pinList.selectedPin)
    }

    removeWishlist = (index) => {
        let completeWishlist = this.state.completeWishlist.slice();
        completeWishlist.splice(index,1)
        this.setState({completeWishlist: completeWishlist}) 
    }

    addItem = ()=> {
        const {wishlist} = this.state;
        const {quantity} = this.state;
        const {completeWishlist} = this.state;
        const {somethingInCart} = this.state;
        if(wishlist === '' || quantity === '')
        {

        }
        else {
        completeWishlist.push(wishlist + "-" + quantity);//adding to the array
        this.setState({
            completeWishlist: completeWishlist,
        })
        // console.log(this.clearRef);
        this.setState({
            wishlist: '',
            quantity: '',
            somethingInCart: true
        })

        }
    }
    
    checkout(){
        // console.log('check......'+this.state.userID.address);
        if(this.state.somethingInCart)
        {
            this.setState({
                checkoutClicked: true,
            })
        }
        else{
          alert('Oops !, Your Cart Is Empty')
        }  
    }

    orderNow =()=>{
        //TODO: here we will add order to databse and remove the add order in checkout() function
        //in checkout() function only enable checkOut clicked and do conditional rendering of address and phone number.
        //TODO: or better as of now in beta mode make a new entry of address with phone number and PIN in cart node.
        db.addItemToCartPerUser(this.state.userID, this.state.completeWishlist,new Date(),pinList.selectedPin, this.state.addr, this.state.phone);
        //removing all items from completeWishlist;
        this.setState({
            completeWishlist: [],
        })

        this.props.history.push('/MyOrders')
    }


    componentDidMount() {
    //here we are grabbing the instances of the current loggedin user.
    // console.log('componnent did mout is calling....')
    // const { loggedUser } = this.props;
    this.setState({
        userID: this.props.loggedUser.uid,
        addr: this.props.loggedUser.uid.address,
        phone: this.props.loggedUser.phoneNumber,
      });
    db.doGetAnUnser(this.props.loggedUser.uid).once('value',(snapshot) => {
        // console.log(snapshot.val()) // giving all list of data in that partivular UID
      this.setState({
        addr: snapshot.val().address,
        phone: snapshot.val().phoneNumber,
        loading: false
      });
    });
    // console.log("xxxxxxxxxx"+ this.state.userID.addr);
    // u=loggedUser.uid;
  }


    renderWishlist() {
        return this.state.completeWishlist.map((item, index)=> {
            return (
            <Card body style={{ backgroundColor: '#f8f8ff', borderColor: '#fff5ee' }}>
                
                <CardText key={index}>{item}  
                </CardText>
                <small><Button color="info"
                            onClick={this.removeWishlist.bind(this,index)}> Remove
                </Button></small>
            </Card>
            )
        })

    }

    render() {
        // console.log("item entry.......",this.state)
        return (
            <div className="container">
                <h5 style={{color:'#b0306a'}}>{`Selected Shop Is - ${pinList.selectedPin}`}</h5>
                <div className="row">
                    {/* this div is for entering item and add to cart */}
                    <div className="col-md-6">
                        <div className="form-group">
                            <input className="form-control"
                                ref= {this.clearRef}
                                placeholder="Type here what you want ?"
                                value= {this.state.wishlist} //this value is important, as without this we cannot erase the input field 
                                onChange={({target})=>this.setState({wishlist: target.value})}
                               
                            />
                            
                            <input className="form-control"
                                ref= {this.clearRef}
                                placeholder="Type here the quantity ?"
                                value= {this.state.quantity}
                                onChange={({target})=>this.setState({quantity: target.value})}
                            />

                            <Button outline color="#fff0f5"
                                    style={{marginTop: '2px',width: '100%', backgroundColor:'#fff0f5',borderColor:'#d8bfd8'}}
                                    onClick={
                                        this.addItem
                                    }
                            >
                            Add To cart
                            </Button>
                        </div>
                    </div>
                    <Divider />
                    <div className="col-md-6">
                    <small style={{color:'#b0306a'}}>Items in cart:</small>
                        <ul className="list-group">
                            {this.renderWishlist()}

                        </ul>
                    </div>
                    
                
                    <Button outline color="#fff0f5"
                        style={{marginTop: '15px',marginBottom: '15px', width:'100%', backgroundColor:'#fff0f5', borderColor:'#d8bfd8'}}
                        onClick={()=>{this.checkout()}}
                        > Proceed to checkout
                    </Button>
                
                {/* THIS DIV IS TO CONFIRM THE ADDRESS AND PHONE NUMBER */}
              {
                    this.state.checkoutClicked 
                    ?
                        <div style={{margin:'10px', width:'100%'}}>
                            <Label>Confirm Address</Label>
                            <input 
                                className="form-control"
                                ref= {this.clearRef}
                                name= "address"
                                placeholder="Type delivey adress !"
                                value= {this.state.addr}
                                onChange={({target})=>this.setState({addr: target.value})}>
                            </input>
                            <Label>Confirm Phone No.</Label>
                            <input 
                                className="form-control"
                                ref= {this.clearRef}
                                name= "Contact"
                                placeholder="Type phone number"
                                value= {this.state.phone}
                                onChange={({target})=>this.setState({phone: target.value})}>
                            </input>
                            <Button 
                                outline color="#fff0f5"
                                style={{marginTop: '2px',width: '100%', backgroundColor:'#fff0f5',borderColor:'#d8bfd8'}}
                                onClick={()=>{this.orderNow()}}
                                > CONFIRM and ORDER ?
                            </Button>                            
                        </div>
                        :
                        null

                  }
                
                </div>

            </div>


        )


    }


}
const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(ItemEntry); //grants authorization to open endpoint if an user is signed in

// export default ItemEntry;

